declare const jQuery: any;
const $ = jQuery;

export function initSimpleContentAnchorMenu(): void
{
    //Simple content anchor menu block
    var i = 0;
    var ids = [];
    var title = [];
    
    $(".simple-content-anchor").each(function(){
        if( $(this).attr('id') ) { //if id exists
            ids[i++] = '<li><a href="#' + $(this).attr('id') + '"><div>' + $(this).attr('title') + '</div></a></li>';
        };
    });

    ids.forEach(SimpleContentAnchorID);
    function SimpleContentAnchorID(item, index) {
        document.querySelector(".simple-content-anchor-menu > div > ul.anchors").innerHTML += item;
    };

}